import React from 'react';
import PropTypes from 'prop-types';
import fr from 'facet-rest';
import MetaForm from 'Components/ComponentLibrary/Organisms/MetaForm';
import Content from './Content';
import metaOverrideSet from './metaOverrideSet';

const NoTemplateTemplate = ({
  collection,
}) => {
  return (
    <MetaForm
      metaOverrideSet={metaOverrideSet}
      collection={collection}
      layout={Content}
    />
  );
};

NoTemplateTemplate.propTypes = {
  collection: PropTypes.instanceOf(fr.Collection).isRequired,
};

export default NoTemplateTemplate;
